module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.pageTitle,
      "visible": _vm.showDialog,
      "show-close": false,
      "top": "5%"
    }
  }, [_c('div', {
    staticClass: "panel-collapse collapse in",
    attrs: {
      "aria-expanded": "true",
      "id": "createFile"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-default box-body"
  }, [_c('el-form', {
    ref: "fileForm",
    staticClass: "has-disabledField",
    attrs: {
      "model": _vm.fileForm,
      "rules": _vm.rules
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "order_type"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function (val) {
        return _vm.disProduct(val, true)
      }
    },
    model: {
      value: (_vm.fileForm.order_type),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "order_type", $$v)
      },
      expression: "fileForm.order_type"
    }
  }, _vm._l((_vm.orderType), function(item) {
    return _c('el-option', {
      key: item.order_type,
      attrs: {
        "label": item.order_type_str,
        "value": item.order_type
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产品名称",
      "prop": "product_id"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.productSearchItem,
      "props": _vm.productSearchProps
    },
    on: {
      "change": function (val) {
        return _vm.handleOptionData(val, true)
      }
    },
    model: {
      value: (_vm.fileForm.product_id),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "product_id", $$v)
      },
      expression: "fileForm.product_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请金额",
      "prop": "apply_price"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.fileForm.apply_price),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "apply_price", $$v)
      },
      expression: "fileForm.apply_price"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申请用途",
      "prop": "apply_purpose"
    }
  }, _vm._l((_vm.applyPurpose), function(radio, key) {
    return _c('el-radio', {
      key: key,
      attrs: {
        "label": radio.value
      },
      model: {
        value: (_vm.fileForm.apply_purpose),
        callback: function($$v) {
          _vm.$set(_vm.fileForm, "apply_purpose", $$v)
        },
        expression: "fileForm.apply_purpose"
      }
    }, [_vm._v(_vm._s(radio.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('h4', {
    staticClass: "dialog-item-title"
  }, [_vm._v("客户信息")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.fileForm.name),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "name", $$v)
      },
      expression: "fileForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号1",
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.fileForm.phone),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "phone", $$v)
      },
      expression: "fileForm.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号2",
      "prop": "phone2"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.fileForm.phone2),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "phone2", $$v)
      },
      expression: "fileForm.phone2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "idcard"
    }
  }, [_c('el-input', {
    on: {
      "change": _vm.idCardChange
    },
    model: {
      value: (_vm.fileForm.idcard),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "idcard", $$v)
      },
      expression: "fileForm.idcard"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "sex"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.fileForm.sex),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "sex", $$v)
      },
      expression: "fileForm.sex"
    }
  }, _vm._l((_vm.userSexItem), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出生年月",
      "prop": "birthday"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.fileForm.birthday),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "birthday", $$v)
      },
      expression: "fileForm.birthday"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "身份证有效期",
      "prop": "idcard_validity"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "输入'长期' 或 日期（格式：2000-01-01）"
    },
    model: {
      value: (_vm.fileForm.idcard_validity),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "idcard_validity", $$v)
      },
      expression: "fileForm.idcard_validity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "户口所在地",
      "prop": "resident_address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.fileForm.resident_address),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "resident_address", $$v)
      },
      expression: "fileForm.resident_address"
    }
  }, [_c('el-cascader', {
    attrs: {
      "slot": "prepend",
      "options": _vm.cities.list,
      "props": _vm.cities.props
    },
    on: {
      "active-item-change": function (val) {
        return _vm.citiesItemChange(val, true)
      }
    },
    slot: "prepend",
    model: {
      value: (_vm.fileForm.user_cityId),
      callback: function($$v) {
        _vm.$set(_vm.fileForm, "user_cityId", $$v)
      },
      expression: "fileForm.user_cityId"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading,
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e4de408!./~/vue-loader/lib/selector.js?type=template&index=0!./src/financialSystem/component/formTpl/createFile.vue
// module id = 1220
// module chunks = 105